<template>
  <div class="container page" style="background-color: #f4f4f4;">
    <van-nav-bar :title="$t('setting.base_setting')" class="nav-bar">
      <template #left>
          <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
    </van-nav-bar>
    <div style="height: 10px;background-color: transparent;"></div>
    <div class="main-content">
      <van-form @submit="onSubmit">
        <van-field
          v-model="name"
          required
          name="real_name"
          :label="$t('setting.real_name')"
          :placeholder="$t('setting.name_place')"
          :rules="[{ required: true, message: $t('setting.name_place') }]"
        />
        <van-field
          v-model="username"
          name="username"
          :label="$t('minex.nickname')"
          :placeholder="$t('minex.nickname')"
          :rules="[{ required: true, message: $t('minex.nickname_place') }]"
        />
        <van-field
          v-model="phone"
          name="phone"
          :label="$t('setting.mobile')"
          :placeholder="$t('setting.mobile_place')"
          :rules="[{ message: $t('minex.phone_invalid'),pattern:/^1\d{10}$/ }]"
        />
        <div style="margin: 32px 24px;">
          <van-button round block type="info" native-type="submit">{{ $t("q59") }}</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      username: '',
      phone: '',
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onSubmit(values) {
      console.log('submit', values);
      this.$http({
        method: 'post',
        url: 'updateUserInfo',
        data:{
          name: this.name,
          username: this.username,
          phone: this.phone,
        }
      }).then(res => {
        this.$toast(res.msg);
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name=this.userInfo.name
          this.username=this.userInfo.username
          this.phone=this.userInfo.phone
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.main-content{
.van-cell{
  background: #fff;
  box-sizing: border-box;
  width: initial;
  border-radius: 10px;
  font-size: 28px;
  padding: 26px 24px;
  /deep/ .van-field__control{
    color: #333;
  }
  /deep/ .van-field__error-message{
    font-size: 24px !important;
  }
  /deep/&::before{
    font-size: 36px !important;
  }
}
.van-button{
  height: 88px;
  font-size: 28px;
}
}
</style>
